import styled from '@emotion/styled'

export const StyleHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  padding: 10px 15px;
`

export const StyleHeading = styled.h2`
  font-size: 16px;
  font-weight: 600;
`

export const StyleSearchWrapper = styled.div`
  border: 1px solid ${(props: any) => props.theme.colors.inputBorder};
  height: 40px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  padding: 0px 5px;
`

export const StyleInputSearch = styled.input`
  height: 35px;
  padding: 0px;
  text-indent: 5px;
  width: 100%;
  outline: none;
  border: 0px;
  &::placeholder {
    font-size: 12px;
    color: ${(props: any) => props.theme.colors.placeholder};
    font-weight: 300;
  }
`
